import { Control, Controller } from 'react-hook-form';
import ReactSelect from 'react-select';

import cx from 'classnames';

import { FieldErrorMessage } from 'components/Form/FieldErrorMessage/FieldErrorMessage';

import { customSelectStyles } from './customStyles';

import s from './Select.module.css';

export type TSelectProps = {
  id: string;
  name: string;
  label: string;
  className?: string;
  control?: Control<any>;
  options: {
    label: string;
    value: string | number;
  }[];
  isSearchable?: boolean;
  error?: string;
  onChange?: (...event: any[]) => void;
  value?: any;
  onBlur?: (...event: any[]) => void;
};

export const Select = ({
  id,
  name,
  label,
  className,
  control,
  options,
  isSearchable = false,
  error,
  onChange,
  value,
  onBlur,
}: TSelectProps) => {
  return (
    <div className={cx(s.root, error ? s.error : null, className)}>
      <label id={`${id}-label`} className={cx(s.label)}>
        <span>{label}</span>
      </label>
      <div className={s.selectOuterContainer}>
        <div className={s.selectInnerContainer}>
          {!!control ? (
            <Controller
              name={name}
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <ReactSelect
                  id={id}
                  aria-labelledby={`${id}-label`}
                  styles={customSelectStyles}
                  options={options}
                  value={options.find((o) => o.value === value)}
                  onChange={(val) => onChange(val?.value)}
                  onBlur={onBlur}
                  isSearchable={isSearchable}
                  classNamePrefix="gg-dropdown"
                />
              )}
            />
          ) : (
            <ReactSelect
              id={id}
              aria-labelledby={`${id}-label`}
              styles={customSelectStyles}
              options={options}
              value={options.find((o) => o.value === value)}
              onChange={onChange}
              onBlur={onBlur}
              isSearchable={isSearchable}
              classNamePrefix="gg-dropdown"
            />
          )}
        </div>
        <div className={s.selectErrorContainer}>
          <FieldErrorMessage
            id={id}
            error={error}
            errorClassName={s.selectError}
          />
        </div>
      </div>
    </div>
  );
};
